import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').FormError}
 */
const FormError = ({
    error
}) => {
    return (
        <p className='text-red type-style-tiny pt-6'>
            {String(error.message)}
        </p>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default FormError;
